module.exports = __webpack_public_path__ + "assets/img/style_lang.2980f95f.jpg";